function calculateVat(price) {
  const VAT_RATE = 0.2; // 20% VAT
  const vat = price * VAT_RATE;
  console.log(vat.toFixed(2));
  return parseFloat(vat.toFixed(2));
}

export { calculateVat };
